import moment from 'moment';
/**
 * A common way of displaying time, sometimes called time ago or relative time.
 */
function relativeTimeFromNow(input = moment()) {
    if (moment.isMoment(input)) {
        input.locale(moment.locale());
        return input.fromNow();
    }
    return moment(input).fromNow();
}
/**
 * The opposite of {@link relativeTimeFromNow}.
 */
function relativeTimeToNow(input = moment()) {
    if (moment.isMoment(input)) {
        input.locale(moment.locale());
        return input.toNow();
    }
    return moment(input).toNow();
}
export { relativeTimeFromNow, relativeTimeToNow, };
//# sourceMappingURL=relative-time.js.map